module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "person-ranking"
  }, [_c('ranking-list', {
    attrs: {
      "items": _vm.leaderboards
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade-in-up",
      "appear": ""
    }
  }, [_c('div', {
    staticClass: "current-ranking"
  }, [_c('div', {
    staticClass: "me"
  }, [_vm._v("我")]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('webp-image', {
    attrs: {
      "src": _vm.mine.icon,
      "alt": "avatar",
      "width": "100%",
      "height": "100%"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.mine.name)), _c('br'), _c('small', [_vm._v("第 " + _vm._s(_vm.mine.ranking) + " 名")])]), _vm._v(" "), _c('div', {
    staticClass: "course"
  }, [_vm._v(_vm._s(_vm.duration2course(_vm.mine.duration)))]), _vm._v("节\n    ")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /Users/Mee/Work/lls-with-tfchina/~/vue-loader/lib/template-compiler?{"id":"data-v-294cc5a8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/Users/Mee/Work/lls-with-tfchina/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PersonRanking.vue
// module id = 202
// module chunks = 1